const areAllInstancesAreValid = (instances) => {
  return Object.values(instances).every((instance) => {
    return Object.values(instance).every((field) => field === true)
  })
}

const enforceGeometryMustExist = () => {
  return import.meta.env.REACT_APP_ENFORCE_GEOMETRY_MUST_EXIST === 'true'
}

const DELIST_ALL_PROPOSAL_PURPOSE = 6

export const getUncompletedProposalSections = (validation, proposalPurpose) => {
  if (!validation) {
    return []
  }

  const result = []
  const isSectionValid = (section) => {
    if (!section || typeof section !== 'object') {
      return false
    }
    return Object.values(section).every((element) => element === true)
  }

  if (!isSectionValid(validation.about)) {
    result.push('About')
  }

  if (!isSectionValid(validation.details)) {
    result.push('Site Details')
  }

  const isDelistAllPurpose = Number(proposalPurpose) === DELIST_ALL_PROPOSAL_PURPOSE

  const hasInvalidAssessment =
    !isDelistAllPurpose &&
    (!validation.assessmentsAvailable ||
      ['criterionC', 'criterionE', 'ecoSystem', 'species', 'assessmentParameters', 'congregations'].some(
        (key) => validation[key] && !areAllInstancesAreValid(validation[key])
      ))

  if (hasInvalidAssessment) {
    result.push('Assessment')
  }

  if (
    validation.geometry &&
    enforceGeometryMustExist() &&
    !validation.geometry.notConfigured &&
    !validation.geometry.validPolygon
  ) {
    result.push('Map Page')
  }

  return [...new Set(result)]
}
